'use client'

import React, { useContext, useState } from 'react'
import { useWindowSize } from '@planda/design-system';
import {
  Box,
  Button,
  Flex,
  Heading,
  IconButton,
  Tabs,
  Text,
} from '@radix-ui/themes'
import { AiOutlineClose, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai'
// import { LuMessageSquarePlus } from 'react-icons/lu'
import { LuFolderCheck, LuFolderSync } from "react-icons/lu";
import { ChatContext, Persona } from '@/components'
import SettingsInputs from '@/components/SettingsInputs';
import { CalendarId } from '@/types/calendar'
import ManualFill from './ManualFill'


export interface PersonaPanelProps { }

export const SyncTypes: Persona[] = [
  {
    id: CalendarId.GOOGLE,
    role: 'system',
    name: 'Google Calendar',
    description: 'Sync with Google Calendar',
    prompt: 'You are an AI assistant that helps people schedule meetings.',
    isDefault: true,
  },
  {
    id: CalendarId.MANUAL,
    role: 'system',
    name: 'Manual',
    description: 'Drag to fill in availabilities',
    prompt: 'You are an AI assistant that helps people schedule meetings.',
    isDefault: false
  },
  {
    id: CalendarId.GOOGLE2,
    role: 'system',
    name: '2nd Google Calendar',
    description: 'Sync with 2nd Google Calendar',
    prompt: 'You are an AI assistant that helps people schedule meetings.',
    isDefault: false,
  },
]

const PersonaPanel = (_props: PersonaPanelProps) => {
  const {
    onEditPersona,
    onClosePersonaPanel
  } = useContext(ChatContext)

  const {
    syncStatus = {}
  } = useContext(ChatContext)

  const { isMobile } = useWindowSize('mobile')

  return (
    <Flex
      direction="column"
      width="100%"
      height="100%"
      className="absolute top-0 z-10 flex-1"
      style={{ backgroundColor: 'var(--color-background)' }}
    >
      <Flex
        justify="between"
        align="center"
        py="3"
        px="4"
        style={{ backgroundColor: 'var(--gray-a2)' }}
      >
        <Heading size="4">Saved Availabilities</Heading>
        <IconButton
          size="2"
          variant="ghost"
          color="gray"
          radius="full"
          onClick={onClosePersonaPanel}
        >
          <AiOutlineClose className="size-4" />
        </IconButton>
      </Flex>
      <SettingsInputs className='mx-auto my-3 md:hidden' />
      <Tabs.Root style={{ minHeight: 0 }} defaultValue="account">
        {/* <Tabs.List> */}
        {/* <Tabs.Trigger value="account">Primary (default)</Tabs.Trigger> */}
        {/* <Tabs.Trigger value="documents">Documents</Tabs.Trigger> */}
        {/* <Tabs.Trigger value="settings">Settings</Tabs.Trigger> */}
        {/* </Tabs.List> */}
        {/* <ScrollArea className="flex-1" type="auto" scrollbars="vertical"> */}
        <Flex direction={isMobile ? "column" : "row"} className="px-4 max-h-full flex-col md:flex-row">
          <Flex direction='column' className="divide-y">
            {SyncTypes.filter(prompt => prompt.id !== CalendarId.MANUAL).map((prompt) => {
              const isSynced = (prompt.id && syncStatus[prompt.id as CalendarId]) ? 'grass' : undefined
              return (
                <Flex
                  key={prompt.id}
                  align="center"
                  justify="between"
                  gap="3"
                  py="3"
                  style={{ borderColor: 'var(--gray-a5)' }}
                >
                  <Box>
                    <Text as="p" size="3" weight="bold" className="mb-2">
                      {prompt.name}
                    </Text>
                    <Text as="p" size="2" className="line-clamp-2">
                      {prompt.description || ''}
                    </Text>
                  </Box>
                  <Flex gap="3">
                    {prompt.id !== CalendarId.MANUAL && <IconButton
                      size="2"
                      variant="soft"
                      radius="full"
                      color={isSynced}
                      // color={(prompt.id && syncStatus[prompt.id as CalendarId]) ? 'grass' : undefined}
                      onClick={() => {
                        // onCreateChat?.(prompt)
                      }}
                    >
                      {isSynced ? <LuFolderCheck className="size-4" /> : <LuFolderSync className="size-4" />}
                    </IconButton>}
                    {/* <IconButton
                    size="2"
                    variant="soft"
                    radius="full"
                    onClick={() => {
                      // onCreateChat?.(prompt)
                    }}
                  >
                    <LuMessageSquarePlus className="size-4" />
                  </IconButton> */}
                    {prompt.id !== CalendarId.MANUAL && <IconButton
                      size="2"
                      variant="soft"
                      color="gray"
                      radius="full"
                      onClick={() => {
                        onEditPersona?.(prompt)
                      }}
                    >
                      <AiOutlineEdit className="size-4" />
                    </IconButton>}
                    <IconButton
                      size="2"
                      variant="soft"
                      color="crimson"
                      radius="full"
                      onClick={() => {
                        // onDeletePersona?.(prompt)
                      }}
                    >
                      <AiOutlineDelete className="size-4" />
                    </IconButton>
                  </Flex>
                </Flex>
              )
            })}
            {/* <Separator className='w-full' /> */}
          </Flex>
          <ManualFill />
        </Flex>
        {/* </ScrollArea> */}
      </Tabs.Root>
    </Flex>
  )
}

export default PersonaPanel
